import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateDiary } from "../../api/CALENDAR/calendar";

export const useUpdateDiary = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }) => updateDiary(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["calendarEvents"] });
    },
  });
};
